import { _ } from "libs";
import React, { useState, FC } from "react";
import { SubscriptionPlan, SubscriptionPeriod } from "../types";
import Currency from "./currency";
import reactToString from "../libs/reactToString";

type onSubscribeClicked = (plan: SubscriptionPlan, period: "year" | "month") => void;

type Props = {
	subscriptionPlan: SubscriptionPlan;
	onSubscribeClicked?: onSubscribeClicked;
};

const SubscriptionWindow: FC<Props> = ({ onSubscribeClicked, subscriptionPlan }: Props) => {
	const [acceptedConditions, setAcceptedConditions] = useState(false);
	const [period, setPeriod] = useState("year" as "year" | "month");

	let price;

	if (period === "year") {
		price = subscriptionPlan.year ? subscriptionPlan.year.amount / 100 / 12 : 0;
	} else {
		price = subscriptionPlan.month.amount / 100;
	}

	let difference = (subscriptionPlan.month.amount * 12 - subscriptionPlan.year.amount) / 100;

	return (
		<div className="product">
			<div className="title">{subscriptionPlan.product.name}</div>
			<div className="description">{_(subscriptionPlan.product.metadata.description_label)}</div>
			{subscriptionPlan.product.metadata.description_url ? (
				<div className="learnMore">
					<a
						href={subscriptionPlan.product.metadata.description_url}
						className="link blue"
						target="_blank"
						rel="noopener noreferrer"
					>
						{_("learnMore")} →
					</a>
				</div>
			) : null}
			<div className="segmentedControl segmentedControlOptions2">
				<div
					className={`segmentedControlOption ${period === "year" ? "active" : ""}`}
					onClick={() => setPeriod("year")}
				>
					{_("subscription.billing.annual")}
				</div>
				<div
					className={`segmentedControlOption ${period === "month" ? "active" : ""}`}
					onClick={() => setPeriod("month")}
				>
					{_("subscription.billing.monthly")}
				</div>
			</div>
			<div className="pricing">
				<div className="firstLine">
					<div className="value">
						<Currency amount={price} currency={(subscriptionPlan[period] as SubscriptionPeriod).currency} />
					</div>
					<div className="period">/ month</div>
				</div>
				<div className="secondLine">
					{period === "year" ? (
						<span>
							{_("subscription.inTotal")}
							&nbsp;
							<Currency
								amount={subscriptionPlan.year.amount / 100}
								currency={subscriptionPlan.year?.currency || "CHF"}
							/>
							&nbsp;
							{_("subscription.perYear")}
						</span>
					) : (
						<span className="link orange" onClick={() => setPeriod("year")}>
							{_("subscription.saveWithAnnualBilling", null, { difference })}
						</span>
					)}
				</div>
			</div>
			<div className="acceptTerms">
				<div className="field checkbox">
					<input
						id="acceptSubscriptionTerms"
						type="checkbox"
						onChange={(e) => {
							setAcceptedConditions(e.target.checked);
						}}
					/>
					<label
						htmlFor="acceptSubscriptionTerms"
						dangerouslySetInnerHTML={{
							__html: _("subscriptionForm.acceptTerms.label", null, {
								termsLink: reactToString(
									<a
										href={subscriptionPlan.product.metadata.terms_url}
										className="plain"
										target="_blank"
										rel="noopener noreferrer"
									>
										{_("links.termsOfService")}
									</a>
								),
							}),
						}}
					/>
				</div>
			</div>
			<div className="buttons">
				<button
					disabled={!acceptedConditions}
					className="button green fullWidth"
					onClick={() => {
						onSubscribeClicked(subscriptionPlan, period);
					}}
				>
					{_("continueBtn")}
				</button>
			</div>
		</div>
	);
};

export default SubscriptionWindow;
